import React from 'react';

const CompleteIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-active" />
    </div>
  );
};

export default CompleteIcon;
